define('view/disclosure/modals/reason.for.modification.modal',['require','exports','module','underscore','uikit/uikit','blockit','fukit','backbone.radio','bluebird','datakit/util/url','model/provisional.organization.model'],function(require, exports, module) {
  //prettier-ignore
  var _                             = require('underscore'),
      UIKit                         = require('uikit/uikit'),
      BlocKit                       = require('blockit'),
      Factory                       = require('fukit').Factory,
      Radio                         = require('backbone.radio'),
      Promise                       = require('bluebird');
      url                           = require('datakit/util/url'),
      ProvisionalOrganizationModel  = require('model/provisional.organization.model'),

      //Radio channels
      disclosureConfirmationChannel = Radio.channel('disclosureConfirmationChannel'),
      UIChannel                     = Radio.channel('UIChannel');

  var ReasonForModificationModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      closable: true,
    }),
    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'Reason for modification',
    },
    content: {
      type: UIKit.Modal2.ContentView,
      components: [
        {
          type: UIKit.Text,
          text: 'What is the reason you are modifying this disclosure?',
        },
        {
          type: BlocKit.FormContainerView,
          basic: true,
          components: [
            {
              name: 'commentInput',
              content: {
                type: UIKit.Input,
                placeholder: 'Add required comment here',
                rowCount: 4,
                multiLine: true,
                behaviors: {
                  //check if input value exists and contain whitespace
                  verifyTextEnableButton: {
                    behaviorClass: Mn.Behavior.extend({
                      onChangeValue: function() {
                        var comment = this.view.getOption('value');
                        var isButtonDisabled;
                        if (comment && /\S/.test(comment)) {
                          isButtonDisabled = false;
                        } else {
                          isButtonDisabled = true;
                        }
                        disclosureConfirmationChannel.trigger('input:validation', isButtonDisabled);
                        disclosureConfirmationChannel.trigger('comment:text', comment);
                      },
                    }),
                  },
                },
              },
            },
          ],
        },
      ],
    },
    actions: {
      components: [
        {
          type: UIKit.Modal2.DenyButtonView,
          text: 'Cancel',
        },
        {
          type: UIKit.Modal2.ConfirmButtonView,
          text: 'Submit Disclosure',
          icon: '',
          color: 'primary',
          disabled: true,
          behaviors: {
            //disable the button initially until text is entered
            toggleConfirmReviewButtonBehavior: {
              behaviorClass: Mn.Behavior.extend({
                onRender: function() {
                  this.listenTo(disclosureConfirmationChannel, 'input:validation', function(isButtonDisabled) {
                    if (this.view.getOption('disabled') !== isButtonDisabled) {
                      this.view.disabled = isButtonDisabled;
                      this.view.render();
                    }
                  });
                },
              }),
            },

            submitCommentBehavior: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function() {
                  var commentJSON;

                  this.listenTo(disclosureConfirmationChannel, 'comment:text', function(comment) {
                    commentJSON = { message: comment };
                  });

                  this.listenTo(this.view, 'press', function() {
                    var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
                    var taskId = workflowTaskModel.get('id');
                    var disclosureCommentModel = Radio.request(
                      'AppKit.resourceService',
                      'resource',
                      'disclosureCommentModel'
                    );
                    var orgModel = new ProvisionalOrganizationModel();
                    var disclosureId = Radio.request('AppKit.resourceService', 'resource', 'disclosure').get('id');

                    orgModel.urlParams({ disclosureId: disclosureId });

                    Promise.try(function() {
                      return disclosureCommentModel.save(commentJSON, {
                        url: url.template('/api/v1/coi-workflow/runtime/tasks/:taskId/comments', { taskId: taskId }),
                      });
                    })
                    // COI-894: When modified disclosure is submitted, it is still assigned to a previous reviewer
                    // COI-1606: Auto assign after Modify disclosure is broken: I changed order of steps: 1. clean old
                    // reviewer and then 2. SUBMIT_MODIFY workflow
                    .then(function() {
                      return orgModel.clearReviewerAssignment();
                    })
                    .then(function() {
                      var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
                      var taskJSON = [
                        {
                          name: 'editDisclosureModification',
                          value: 'SUBMIT_MODIFY',
                          type: 'string',
                        },
                      ];

                      return workflowTaskModel.completeTask(taskJSON);
                    })
                   .then(function() {
                      $('#coiWaitMessage').addClass('hidden');
                      UIChannel.request('modify:submit:enable');
                      UIChannel.request('trigger:completed:task');

                      return true;
                    })
                    .catch(function(error) {
                      console.log('error saving comment or task', error);

                      if(error.status && error.status === 504) {
                        // treat a 504 as if everything finished correctly
                        UIChannel.request('trigger:completed:task');
                      }

                      UIChannel.request('proposal:ui:reset');
                    })
                  });
                },
                onClose: function() {
                  this.stopListening();
                },
              }),
            },
          },
        },
      ],
    },
  });

  module.exports = ReasonForModificationModal;
});

